<template>
    <nav
        id="sidebar-border"
        ref="sidebar"
        class="sidebar sidebar-dark"
    >
        <div :class="['sidebar-sticky', (value) ? 'show' : '']">
            <b-button-close
                class="mobile-only"
                @click="toggleSidebar()"
            >
                &times;
            </b-button-close>
            <AdminWidget/>
            <CurrentSemesterWidget />
            <hr/>
            <router-link
                :to="{ name: 'my_account' }"
                class="nav-link"
                exact
            >
                <font-awesome-icon style="width: 50px;" icon="user-circle" size="lg"></font-awesome-icon>
                My Account
            </router-link>
            <b-skeleton-wrapper
                :loading="loading"
            >
                <template #loading>
                    <ul class="nav">
                        <li
                            class="nav-item mt-3"
                            v-for="i in 5"
                            :key="i"
                        >
                            <b-skeleton width="100%"></b-skeleton>
                        </li>
                    </ul>
                </template>
                <ul class="nav">
                    <li
                        class="nav-item"
                        v-for="(navbarItem, idx) in sidebarItems"
                        :key="idx"
                        @click="toggleSidebar()"
                    >
                        <a
                            v-if="navbarItem.href"
                            :href="navbarItem.href"
                            class="nav-link"
                        >
                            <font-awesome-icon style="width: 50px;" :icon="navbarItem.icon" size="lg"></font-awesome-icon>
                            {{ navbarItem.label }}
                        </a>
                        <router-link
                            v-else
                            :to="navbarItem.to"
                            class="nav-link"
                            exact
                        >
                            <font-awesome-icon style="width: 50px;" :icon="navbarItem.icon" size="lg"></font-awesome-icon>
                            {{ navbarItem.label }}
                        </router-link>
                    </li>
                </ul>
            </b-skeleton-wrapper>
        </div>
    </nav>
</template>
<script>
import CurrentSemesterWidget from "@/components/sidebar/widgets/CurrentSemesterWidget.vue";
import AdminWidget from '@/components/sidebar/widgets/AdminWidget.vue';

const SIDEBAR_ITEMS_KEY = "SIDEBAR_ITEMS";

export default {
    name: "sidebar",
    props: ["value"],
    data() {
        return {
            defaultTrayClasses: ["tray"],
            trayVisible: "",
            trayCollapsed: " collapsed",
            selected: null,
            sidebarItems: [],
            loading: false
        };
    },
    mounted() {
        this.getSidebarItems();
    },
    methods: {
        getSidebarItems() {
            try {
                var sidebarItems = JSON.parse(sessionStorage.getItem(SIDEBAR_ITEMS_KEY));
                this.sidebarItems = (Array.isArray(sidebarItems)) ? sidebarItems : [];
            } catch(e) {
                this.sidebarItems = [];
            }
            if (this.sidebarItems.length == 0) this.loadSidebarItems();
        },
        loadSidebarItems() {
            this.loading = true;
            this.$api.get(
                "/api/account/get-sidebar-items"
            ).then(({ data: { sidebarItems } }) => {
                this.sidebarItems = sidebarItems;
                this.loading = false;
                sessionStorage.setItem(SIDEBAR_ITEMS_KEY, JSON.stringify(sidebarItems));
            });
        },
        clickTrayItem(index, item) {
            this.selected = index;
            if (item.to) {
                this.$router.push(item.to);
            }
            else if (item.href) {
                window.location.href = item.href;
            }
            if (this.isMobile()) {
                this.toggleTray();
            }
        },
        toggleSidebar() {
            this.$emit("input", !this.value);
        },
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }
    },
    components: { CurrentSemesterWidget, AdminWidget }
}
</script>